import React from 'react'
import CheckedoutServiceTxnTableContainer from './CheckedoutServiceTxnTableContainer'

export default class CheckedoutServiceTxnPanelContainer
  extends React.Component
{
  render() {
    return (
      <div className="w-full">
        <div className="border-t border-gray-200 pt-4 mb-4"></div>
        <CheckedoutServiceTxnTableContainer {...this.props} />
      </div>
    )
  }
}
